import { Router } from "@vaadin/router/dist/vaadin-router.js";
import {
  LitElement,
  TemplateResult,
  property,
  customElement,
  css,
} from "lit-element";
import { html, render } from "lit-html";
import { storeInstance } from "store/index.js";
import "@vaadin/vaadin-split-layout/vaadin-split-layout.js";
import { httpError } from "store/httpError.js";
import "./kb-comment-layout.js";
import KbParser from "../utils/KbParser.js";
import getTargetExternalId from "../utils/getTargetExternalId.js";
import seo from "../utils/seo.js";
import { link } from "fs";

class KbTopic extends LitElement {
  constructor() {
    super();
    this.extIdIndex = 3;
  }

  static get properties() {
    return {
      hash: { type: String },
    };
  }

  connectedCallback() {
    this.subscription = storeInstance.subscribe((state) => {
      this.stateChange(state);
    });
    this.state = storeInstance.state;
    this.string = this.state.strings;
    this.htmlBody = "";
    if (this.node) {
      this.lastNodeHref = this.node?.href;
      this.refreshData();
      this.refreshComments(this.node?.href);
    }
    window.addEventListener("hashchange", this.handleHashChange.bind(this));
  }

  refreshComments(kbrid) {
    storeInstance.dispatch("getComments", kbrid);
  }

  refreshData() {
    // storeInstance.dispatch("getTopicHtmlBody", this.node?.href )    ;
    if (this.node?.href) {
      this.alreadyJumpedToFrag = false;
      PubSub.publish("requestout", null);
      fetch(
        this.state.kb_rest_server +
          "/kb/jrest/getHtmlBody?kbrid=" +
          this.node?.href
      )
        .then(
          function (response) {
            if (!response.ok) {
              httpError(response, storeInstance);
              throw Error(); //to bail out of promise chain
            }
            return response;
          }.bind(this)
        )
        .then((response) => {
          return response.text();
        })
        .then((data) => {
          this.htmlBody = data;
          this.topicContainer = this.shadowRoot.querySelector("#topic");
          this.topicContainer.innerHTML = this.htmlBody;
          this.setSeo(this.htmlBody);
          this._updateResourceSrc();
          this._attacheClickBehavior();
          storeInstance.dispatch("touch");
        })
        .catch(function (error) {})
        .finally(function () {
          PubSub.publish("requestin", null);
        });
    }
  }

  disconnectedCallback() {
    storeInstance.unsubscribe(this.subscription);
  }

  stateChange(state) {
    this.state = state;
    this.string = this.state.strings;
    if (!this.topic_infinite_scroll) {
      if (this.node?.href) {
        if (this.lastNodeHref != this.node?.href) {
          this.lastNodeHref = this.node?.href;
          this.refreshData();
          this.refreshComments(this.node?.href);
        }
      }
    }
    this.myRender();
  }

  myRender() {
    render(this.topicTemplate(), this.shadowRoot);
    // this.topicContainer = this.shadowRoot.querySelector("#topic");
    // this.topicContainer.innerHTML = this.htmlBody;
    // this._attacheClickBehavior();
    this.adoptStyles();
    //this.pdflauncher = this.shadowRoot.querySelector("#pdflauncher");
    //this.pdflauncher.addEventListener("click",this._launchPdf.bind(this));
    // ----
    this.hash = window.location.hash;
    this.highlightFrgmentId();
    // ----
    if (this.state.topic_infinite_scroll && !this.intersector) {
      var mi = document.createElement("mil-intersection-observer");
      mi.thresholds = 1;
      mi.rootMargin = "-100px 0px -500px 0px";
      mi.addEventListener("intersect", this.isIntersecting.bind(this));
      var micontainer = this.shadowRoot.querySelector("#micontainer");
      micontainer.appendChild(mi);
    }

    if (this.node?.fragment && !this.alreadyJumpedToFrag) {
      setTimeout(
        function () {
          // this.alreadyJumpedToFrag = true;
          // this._jumpToFragment(this.node?.fragment);
        }.bind(this),
        100
      );
    }
  }

  highlightFrgmentId() {
    if (this.hash) {
      this.hash = this.hash.replace("#", "");
      let el = this.shadowRoot.querySelector(`[id='${this.hash}']`);
      if (el) {
        el.style.backgroundColor = "yellow";
        el.scrollIntoView({block: "center"});
      }
    }
  }

  setSeo(htmlBody) {
    let title = "";
    const htmlParser = new DOMParser();
    const doc = htmlParser.parseFromString(htmlBody, "text/html");
    if (doc?.querySelector("h1")?.innerText) {
      title = `${doc.querySelector("h1").innerText} - `;
    }
    seo(
      `${title}${this.state.item.itemLang.name}, ${this.state.item.itemLang.description}`
    );
  }

  handleHashChange(e) {
    this.hash = new URL(e.newURL).hash;
    this.refreshData();
    this.myRender();
  }

  _launchPdf(e) {
    e.preventDefault();
    window.location.href = e.currentTarget.href;
  }

  isShortcutLink(newLink) {
    if (this.locationExtId) {
      let linkExternalId = newLink?.split("/")[this.extIdIndex];
      return this.state.item.item.externalId === linkExternalId; // item is targetItem is this case
    }
    return false;
  }

  imputeShortcutExtId(newLink) {
    if (this.isShortcutLink(newLink)) {
      let linkRouteParams = newLink.split("/");
      linkRouteParams[this.extIdIndex] = this.locationExtId
        ? this.locationExtId
        : linkRouteParams[this.extIdIndex];
      return linkRouteParams.join("/");
    }
    return newLink;
  }

  async _handleKbrid(el) {
    let parser = new KbParser();
    parser.setHref(el.getAttribute("href"));
    let parsedLink = parser.parse();
    let newLink = this.imputeShortcutExtId(parsedLink);
    let item = await parser.getItem();
    el.addEventListener("click", async (e) => {
      e.preventDefault();
      if (el.getAttribute("target") === "_blank") {
        window.open(newLink, "_blank");
      }
      storeInstance.dispatch("setState", { property: "item", value: item });
      Router.go(newLink);
    });
  }

  _attacheClickBehavior() {
    var linkElements = this.topicContainer.querySelectorAll("a");
    linkElements.forEach(async (el) => {
      if (KbParser.isKbrid(el.getAttribute("href"))) {
        await this._handleKbrid(el);
      }
    });
  }

  _attacheClickBehavior2() {
    var aLinks = this.topicContainer.querySelectorAll("a");
    aLinks.forEach(
      function (link) {
        var linkType = null;
        var hrefValue = link.getAttribute("href");

        if (hrefValue.substr(0, 1) == "#") {
          linkType = "fragment";
        } else {
          if (hrefValue.substr(0, 10).toLowerCase() == "http:///kb") {
            linkType = "crossLink";
          } else {
            switch (hrefValue.substr(0, 3).toLowerCase()) {
              case "xdx":
                linkType = "KbRid";
                break;
              case "xdb":
                linkType = "resource";
                break;
              case "/co":
                linkType = "resource";
                break;
              case "/sy":
                if (hrefValue.toLowerCase() == "/sysc") {
                  linkType = "resource";
                } else {
                  linkType = "resource";
                }
                break;
              default:
                linkType = "external";
            }
          }
        }
        var att = document.createAttribute("linktype");
        att.value = linkType;
        link.setAttributeNode(att);

        if (linkType == "fragment") {
          link.addEventListener("click", this._fragmentLinkClicked.bind(this));
        }

        if (linkType == "KbRid") {
          link.addEventListener("click", this._topicLinkClicked.bind(this));
          var att2 = document.createAttribute("kbrid");
          att2.value = link.getAttribute("href");
          link.setAttributeNode(att2);
        }
        if (linkType == "crossLink") {
          link.addEventListener("click", this._topicLinkClicked.bind(this));
          var att2 = document.createAttribute("crossLink");
          att2.value = link.getAttribute("href").replace("http:///", "/");
          link.setAttributeNode(att2);
        }

        // just an idea to provide new window functionality
        var parsedPageUrl = new URL(window.location.href);
        var newTabUrl = null;
        var createIcon = false;
        switch (linkType) {
          case "KbRid":
            newTabUrl =
              parsedPageUrl.origin +
              "/kb/" +
              this.state.langCode +
              "/" +
              this._extractExternalId(hrefValue) +
              hrefValue;
            createIcon = true;
            break;
          case "crossLink":
            newTabUrl = parsedPageUrl.origin + hrefValue;
            break;
          case "external":
            newTabUrl = hrefValue;
            createIcon = true;
            break;
          default:
            //need test content for  resource type
            break;
        }
        if (createIcon) {
          var newTabLink = document.createElement("A");
          newTabLink.href = newTabUrl;
          newTabLink.target = "_blank";
          newTabLink.class = "newtablink";
          var domLink = link.insertAdjacentElement("afterend", newTabLink);
          var newTabIcon = document.createElement("iron-icon");
          newTabIcon.icon = "vaadin:external-link";
          var att3 = document.createAttribute("class");
          att3.value = "launchIcon";
          newTabIcon.setAttributeNode(att3);
          var addedIcon = domLink.appendChild(newTabIcon);
        }
      }.bind(this)
    );
  }

  _extractExternalId(kbrid) {
    var aTmp = kbrid.split("_");
    return aTmp[1];
  }

  _updateResourceSrc() {
    var aImages = this.topicContainer.querySelectorAll("img");
    aImages.forEach(
      function (img) {
        var aSrc = img.src.split("/");
        if (aSrc.length > 0) {
          var srcAddress = aSrc[aSrc.length - 1];
          var srcType = null;
          switch (srcAddress.substr(0, 3).toLowerCase()) {
            case "htt":
              srcType = "external";
            case "xdb":
              srcType = "resource";
              break;
            case "/co":
              srcType = "resource";
              break;
            case "/sy":
              srcType = "resource";
              break;
          }
          if ((srcType = "resource")) {
            img.src = "/kb/jrest/getResource?kbrid=" + srcAddress;
          }
        }
      }.bind(this)
    );

    var aVideo = this.topicContainer.querySelectorAll("object");
    aVideo.forEach(
      function (obj) {
        var aSrc = obj.data.split("/");
        if (aSrc.length > 0) {
          var srcAddress = aSrc[aSrc.length - 1];
          var srcType = null;
          switch (srcAddress.substr(0, 3).toLowerCase()) {
            case "htt":
              srcType = "external";
            case "xdb":
              srcType = "resource";
              break;
            case "/co":
              srcType = "resource";
              break;
            case "/sy":
              srcType = "resource";
              break;
          }
          if ((srcType = "resource")) {
            obj.data = "/kb/jrest/getResource?kbrid=" + srcAddress;
          }
        }
        var param = obj.querySelector("param[name='src']");
        if (param) {
          switch (param.value.toLowerCase()) {
            case "htt":
              srcType = "external";
            case "xdb":
              srcType = "resource";
              break;
            case "/co":
              srcType = "resource";
              break;
            case "/sy":
              srcType = "resource";
              break;
          }
          if ((srcType = "resource")) {
            param.value = "/kb/jrest/getResource?kbrid=" + srcAddress;
          }
        }
      }.bind(this)
    );
  }

  _topicLinkClicked(e) {
    e.preventDefault();
    switch (e.currentTarget.getAttribute("linktype")) {
      case "KbRid":
        this.dispatchEvent(
          new CustomEvent("topicLinkClicked", {
            bubbles: true,
            composed: true,
            detail: e.currentTarget.getAttribute("href"),
          })
        );
        break;
      case "crossLink":
        this.dispatchEvent(
          new CustomEvent("crossLinkClicked", {
            bubbles: true,
            composed: true,
            detail: e.currentTarget.getAttribute("href"),
          })
        );
        break;
      case "external":
        //good place for a kbproperty
        document.location = e.currentTarget.getAttribute(href);
        break;
    }
  }

  _jumpToFragment(fragmentId) {
    var targetFragmentElement = this.shadowRoot.querySelector("#" + fragmentId);
    if (targetFragmentElement) {
      var tteRec = targetFragmentElement.getBoundingClientRect();
      this.dispatchEvent(
        new CustomEvent("scrollHelpsetBy", {
          bubbles: true,
          composed: true,
          detail: tteRec.top - this.state.global_screen_specs.headerHeight,
        })
      );
    }
  }

  _fragmentLinkClicked(e) {
    e.preventDefault();
    var fragmentId = e.currentTarget.getAttribute("href");
    if (fragmentId) {
      var targetFragmentElement = this.shadowRoot.querySelector(fragmentId);
      if (targetFragmentElement) {
        var tteRec = targetFragmentElement.getBoundingClientRect();
        this.dispatchEvent(
          new CustomEvent("scrollHelpsetBy", {
            bubbles: true,
            composed: true,
            detail: tteRec.top - this.state.global_screen_specs.headerHeight,
          })
        );
        //this.parentElement.scrollBy(0,tteRec.top -   this.state.global_screen_specs.headerHeight);
      }
    }
  }

  topicTemplate() {
    return html`
      <link
        rel="stylesheet"
        type="text/css"
        href="/kb/themes/${theme}/topic/topic.css"
      />
      <style>
        /* .launchIcon {
          margin-top: -0.3rem;
          margin-left: 0.2rem;
          width: 0.9rem;
        }
        #comments {
          margin-top: 3rem;
        }
        img {
          max-width: 90%;
        }

        h1 {
          font-size: 1.91rem;
        }

        h2 {
          font-size: 1.5rem;
          margin: 1.25rem 0 0.5rem;
        }

        p {
          margin: 0.25rem 0 1rem;
          line-height: 1.45;
        } */
      </style>
      <a
        style="float:right;"
        title="PDF"
        href="/kb/jrest/getHtmlAsPdf?kbrid=${this.node
          ?.href}&title=${encodeURIComponent(this.node?.title)}"
        id="pdflauncher"
        target="_new"
      >
        <img src="/kb/PDF_file_icon.svg" style="width:32px;" />
      </a>
      ${this._io()}
      <div id="topic"></div>
      <div id="comments">
        <kb-comment-layout .kbrid="${this.node?.href}"></kb-comment-layout>
      </div>
    `;
  }

  _io() {
    if (this.state.topic_infinite_scroll) {
      return html`<div id="micontainer"></div>`;
      /*
            return html`<mil-intersection-observer @intersect="${this.isIntersecting.bind(this)}" .thresholds="${[1.00]}" .rootMargin="-100px 0px -500px 0px">            </mil-intersection-observer>`;
            */
    }
  }

  isIntersecting(e) {
    console.log(this.node?.title + " " + e.detail.isIntersecting);
    if (e.detail.isIntersecting) {
      this.dispatchEvent(
        new CustomEvent("topicScrolledIntoPrimaryView", {
          bubbles: true,
          composed: true,
          detail: this.node,
        })
      );
    }
  }
}

customElements.define("kb-topic", KbTopic);
